import classNames from 'classnames';
import React, {CSSProperties, HTMLAttributes, ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import colSizeClassesFromProps from 'ui-library/bs/util/colSizeClassesFromProps';

interface ColProps {
  'aria-labelledby'?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  'xs-offset'?: number;
  'sm-offset'?: number;
  'md-offset'?: number;
  'lg-offset'?: number;
  'xs-push'?: number;
  'sm-push'?: number;
  'md-push'?: number;
  'lg-push'?: number;
  'xs-pull'?: number;
  'sm-pull'?: number;
  'md-pull'?: number;
  'lg-pull'?: number;
  className?: string;
  role?: HTMLAttributes<HTMLDivElement>['role'];
  style?: CSSProperties;
  children?: ReactNode;
  id?: string;
  tabIndex?: number;
  dataTestAttrs?: DataTestAttrs;
}

export default function Col(props: ColProps): JSX.Element {
  const colSizeClasses = colSizeClassesFromProps(props);
  const classString = classNames(props.className, colSizeClasses);
  return (
    <div
      aria-labelledby={props['aria-labelledby']}
      className={classString}
      id={props.id}
      role={props.role}
      style={props.style}
      tabIndex={props.tabIndex}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </div>
  );
}
